var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99985 12.3958L4.54152 14.4792C4.38874 14.5764 4.22902 14.618 4.06235 14.6042C3.89568 14.5903 3.74985 14.5347 3.62485 14.4375C3.49985 14.3403 3.40263 14.2187 3.33318 14.0729C3.26374 13.9271 3.24985 13.7639 3.29152 13.5833L4.20818 9.64582L1.14568 6.99999C1.00679 6.87499 0.919989 6.73263 0.885266 6.57291C0.850544 6.41318 0.860961 6.25693 0.916516 6.10416C0.972072 5.95138 1.05541 5.82638 1.16652 5.72916C1.27763 5.63193 1.43041 5.56943 1.62485 5.54166L5.66652 5.18749L7.22902 1.47916C7.29846 1.31249 7.4061 1.18749 7.55193 1.10416C7.69777 1.02082 7.84707 0.979156 7.99985 0.979156C8.15263 0.979156 8.30193 1.02082 8.44777 1.10416C8.5936 1.18749 8.70124 1.31249 8.77068 1.47916L10.3332 5.18749L14.3748 5.54166C14.5693 5.56943 14.7221 5.63193 14.8332 5.72916C14.9443 5.82638 15.0276 5.95138 15.0832 6.10416C15.1387 6.25693 15.1492 6.41318 15.1144 6.57291C15.0797 6.73263 14.9929 6.87499 14.854 6.99999L11.7915 9.64582L12.7082 13.5833C12.7498 13.7639 12.736 13.9271 12.6665 14.0729C12.5971 14.2187 12.4998 14.3403 12.3748 14.4375C12.2498 14.5347 12.104 14.5903 11.9374 14.6042C11.7707 14.618 11.611 14.5764 11.4582 14.4792L7.99985 12.3958Z",
    fill: "#F88D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.11bb49bf21ae96cfdc04ce77ba8fae47.svg";
export { ForwardRef as ReactComponent };